import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import {
	getReactionsQueryInfo,
	type ReactionsQueryVariablesType,
	type ReactionsQueryDataType,
} from './utils/data.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export function preloadPageReactions({
	pageId,
	containerId,
}: {
	pageId: any;
	containerId: any;
}): Promise<{
	data: ReactionsQueryDataType | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	const { query: reactionsQuery, queryVariables } = getReactionsQueryInfo(
		false,
		pageId,
		containerId,
	);

	return query<ReactionsQueryDataType, ReactionsQueryVariablesType>({
		query: reactionsQuery,
		variables: queryVariables,
	});
}
